import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { WorkExperienceProps } from "pages/home/types";
import { useEffect, useState } from "react";

const WorkExperience = ({
  employmentIndustry = [],
  employmentStatus = [],
  userInfoData,
  onInputChange,
  validationError,
}: WorkExperienceProps) => {
  const employment = userInfoData?.kyc?.employment;
  const [disabledDropdown, setDisabledDropdown] = useState(true);
  const handleEmploymentStatusChange = (event: SelectChangeEvent<string>) => {
    onInputChange("employment", "employment_status", event.target.value);
  };
  const handleEmploymentIndustryChange = (event: SelectChangeEvent<string>) => {
    onInputChange("employment", "employment_industry", event.target.value);
  };

  const handleJobTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onInputChange("employment", "job_role", event.target.value);
  };

  useEffect(() => {
    const lowerCaseStatus = employment?.employment_status?.toLowerCase();

    if (
      lowerCaseStatus === "unemployed" ||
      lowerCaseStatus === "student" ||
      lowerCaseStatus === "retired"
    ) {
      setDisabledDropdown(true);
    } else {
      setDisabledDropdown(false);
    }
  }, [employment]);

  return (
    <Accordion elevation={0}>
      <AccordionSummary
        expandIcon={<ArrowDownwardIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography>Work Experience</Typography>

          <Typography variant="caption" sx={{ color: "gray", lineHeight: 1.8 }}>
            {employment?.employment_status
              ? employment?.employment_status
              : "Incomplete"}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            "& .MuiTextField-root": { m: 1 },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <FormControl sx={{ m: 1, minWidth: 200 }}>
            <InputLabel>Employment Status</InputLabel>
            <Select
              value={employment?.employment_status.toLowerCase() ?? ""}
              onChange={handleEmploymentStatusChange}
              label="Employment Status"
            >
              {employmentStatus &&
                employmentStatus.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          {!disabledDropdown && (
            <FormControl sx={{ m: 1, minWidth: 200 }}>
              <InputLabel>Industry</InputLabel>
              <Select
                value={userInfoData?.kyc?.employment?.employment_industry ?? ""}
                onChange={handleEmploymentIndustryChange}
                label="Industry"
              >
                {employmentIndustry &&
                  employmentIndustry.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}
          {!disabledDropdown && (
            <FormControl
              sx={{
                m: 1,
                minWidth: 200,
                marginLeft: 0,
                marginRight: "15px",
              }}
            >
              <TextField
                key="employment_occupation"
                id="filled-helperText"
                label="Occupation"
                value={employment?.job_role ?? ""}
                onChange={handleJobTitleChange}
                variant="outlined"
                size="medium"
                fullWidth
              />
            </FormControl>
          )}
          {validationError && (
            <Typography color="error" sx={{ mt: 1 }}>
              {validationError}
            </Typography>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default WorkExperience;
